import React from "react";
import { Avatar, Card, Comment, Icon, List, Typography } from "antd";
import pathOr from "ramda/es/pathOr";

const CustomComponent = props => {
	const { preguntaIndex, group, tipoActividad, pregunta, actividad } = props;

	const preguntasS = pathOr([], ["preguntas"], pregunta);
	return (
		<React.Fragment>
			<List
				className="comment-list"
				itemLayout="horizontal"
				dataSource={preguntasS}
				renderItem={(item, i) => {
					const respuesta = Object.values(actividad.respuestas).map(x => {
						return x.respuestas
							.map(s => {
								if (s.numeroPregunta === i + 1) {
									return s;
								}
							})
							.filter(x => !!x)[0];
					});

					return (
						<React.Fragment>
							<Card bordered>
								<Card.Meta
									title={item.titulo}
									description={
										<React.Fragment>
											<Typography.Paragraph>
												{item.description}
											</Typography.Paragraph>
											{tipoActividad === "trivia" && (
												<Typography.Text type="secondary">
													Respuesta Correcta: {item.respuestaCorrecta}
												</Typography.Text>
											)}
										</React.Fragment>
									}
								/>
								{respuesta &&
									respuesta.map((r, index) => {
										return (
											<Card.Meta
												title={item.title}
												description={
													<Comment
														actions={item.actions}
														author={group && group.nombreGrupo}
														avatar={<Avatar icon="user" />}
														content={
															<List.Item>
																<List.Item.Meta
																	title={
																		<div>
																			<Typography.Paragraph>
																				{index + 1}) Respuesta Grupo:{" "}
																				{r && r.respuesta}
																			</Typography.Paragraph>

																			{tipoActividad === "trivia" && (
																				<Typography.Paragraph>
																					{r &&
																						r.respuesta ===
																						item.respuestaCorrecta ? (
																							<Icon
																								type="check"
																								style={{
																									color: "blue",
																									fontSize: 30
																								}}
																							/>
																						) : (
																							<Icon
																								type="close"
																								style={{
																									color: "red",
																									fontSize: 30
																								}}
																							/>
																						)}
																				</Typography.Paragraph>
																			)}
																		</div>
																	}
																/>
															</List.Item>
														}
													/>
												}
											/>
										);
									})}
							</Card>
						</React.Fragment>
					);
				}}
			/>
		</React.Fragment>
	);
};

CustomComponent.defaultProps = {
	pregunta: {},
	preguntaIndex: 0
};

export default CustomComponent;
